(() => {
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
    if (window.__yurchakDispatchStatusBootstrapped) return;
    window.__yurchakDispatchStatusBootstrapped = true;

    const syncDispatchStatus = (data) => {
      if (!data || !data.sectionId || !data.html) return;

      const id = `YurchakDispatch-${data.sectionId}`;
      const current = document.getElementById(id);
      const next = data.html.getElementById(id);

      if (!current || !next) return;

      current.className = next.className;
      current.dataset.state = next.dataset.state || '';
      current.innerHTML = next.innerHTML;
    };

    const bindVariantUpdates = () => {
      if (window.__yurchakDispatchStatusSubscribed) return;
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => syncDispatchStatus(data));
      window.__yurchakDispatchStatusSubscribed = true;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindVariantUpdates, { once: true });
    } else {
      bindVariantUpdates();
    }
  })();
